import styled from 'styled-components';
import { mb, mr, ml, mt, my, px, pt } from '@lendi-ui/spacing';
import { gte } from '@lendi-ui/breakpoint';
import { heading } from '@lendi-ui/typography';

export const AlertsContainer = styled.div`
  ${px('md')}
  ${pt('xs')}
`;

export const Container = styled.div`
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  ${mt('xs')}
  ${ml('lg')}

  > * {
    ${mb('xs')}
    ${mr('xs')}
  }

  ${gte('sm')`
    justify-content: left;
  `};
`;

export const CustomerViewHeading = styled.div`
  ${heading({ size: 'lg' })}
  ${my('md')}
`;
